  <div class="col gap-6 items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
    <div class="col items-center">
      <h2 [ngClass]="[color(), 'text-8xl mb-4 font-bold']">{{ errorCode() }}</h2>
      <h3 class="text-page-heading">{{ errorMessage() }}</h3>
      <span class="text-body-text-regular">{{ errorDescription() }}</span>
    </div>

    <ng-content />
  </div>
